import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/noData_filter.svg'
import _imports_1 from '@/app/ui/assets/svg/ill_spot_search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-874005c0")

_pushScopeId("data-v-874005c0")
const _hoisted_1 = { class: "flex gap-8 items-center" }
const _hoisted_2 = { class: "text-xl font-semibold" }
const _hoisted_3 = { class: "inline-block relative mr-4 text-12px xxl:text-14px w-full" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-y-0 left-0 ml-2 items-center px-2 py-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    class: "w-4",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 4C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10C4 10.7879 4.15519 11.5681 4.45672 12.2961C4.75825 13.0241 5.20021 13.6855 5.75736 14.2426C6.31451 14.7998 6.97595 15.2417 7.7039 15.5433C8.43185 15.8448 9.21207 16 10 16C10.7879 16 11.5681 15.8448 12.2961 15.5433C13.0241 15.2417 13.6855 14.7998 14.2426 14.2426C14.7998 13.6855 15.2417 13.0241 15.5433 12.2961C15.8448 11.5681 16 10.7879 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4ZM4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 11.0506 17.7931 12.0909 17.391 13.0615C17.1172 13.7226 16.7565 14.3425 16.3196 14.9054L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9054 16.3196C14.3425 16.7565 13.7226 17.1172 13.0615 17.391C12.0909 17.7931 11.0506 18 10 18C8.94943 18 7.90914 17.7931 6.93853 17.391C5.96793 16.989 5.08601 16.3997 4.34315 15.6569C3.60028 14.914 3.011 14.0321 2.60896 13.0615C2.20693 12.0909 2 11.0506 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315Z",
      fill: "#000"
    })
  ])
], -1)
const _hoisted_5 = { class: "absolute inset-y-0 right-0 mr-2 items-center px-2 py-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#000"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col",
  style: {"height":"70vh"}
}
const _hoisted_8 = {
  key: 0,
  class: "px-4 py-2"
}
const _hoisted_9 = { class: "text-base font-bold" }
const _hoisted_10 = { class: "grid gap-2 mt-2" }
const _hoisted_11 = {
  key: 1,
  class: "px-4 py-2"
}
const _hoisted_12 = { class: "text-base font-bold pb-4" }
const _hoisted_13 = { class: "grid grid-cols-4 gap-4 py-2 border-b" }
const _hoisted_14 = { class: "break-all text-sm px-2 capitalize" }
const _hoisted_15 = {
  key: 2,
  class: "px-4 py-2"
}
const _hoisted_16 = { class: "text-base font-bold" }
const _hoisted_17 = {
  class: "flex flex-col items-center justify-center",
  style: {"height":"40vh"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-20 h-18 mr-1 max-w-none",
  alt: "no-data-icon"
}, null, -1)
const _hoisted_19 = { class: "font-normal text-gray-lp-600" }
const _hoisted_20 = { class: "font-normal text-gray-lp-600" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-col",
  style: {"height":"70vh"}
}
const _hoisted_22 = {
  class: "px-4 py-2 border-b flex-shrink-0 overflow-auto",
  style: {"max-height":"9rem"}
}
const _hoisted_23 = { class: "text-base font-bold" }
const _hoisted_24 = { class: "grid grid-cols-4 gap-4 py-2 border-b recommendation-container" }
const _hoisted_25 = { class: "break-all text-sm px-2 capitalize" }
const _hoisted_26 = { class: "flex flex-row ml-1 items-start" }
const _hoisted_27 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_28 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_29 = {
  class: "flex",
  style: {"height":"70%"}
}
const _hoisted_30 = {
  tabIndex: "-1",
  class: "relative w-2/5 bg-gray-lp-1000 p-4 overflow-auto recommendation-container"
}
const _hoisted_31 = { class: "pl-2 text-sm capitalize" }
const _hoisted_32 = {
  key: 0,
  class: "w-3/5 bg-gray-lp-1000 p-4 grid gap-2 overflow-auto"
}
const _hoisted_33 = {
  key: 1,
  class: "w-3/5 p-2 overflow-auto list-commodity recommendation-container"
}
const _hoisted_34 = { class: "capitalize" }
const _hoisted_35 = { class: "flex flex-row ml-1 items-center" }
const _hoisted_36 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_37 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_38 = {
  key: 2,
  class: "w-3/5 p-4 flex flex-col items-center mt-20"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-20 h-18 mr-1 max-w-none",
  alt: "reload-icon"
}, null, -1)
const _hoisted_40 = { class: "font-normal text-gray-lp-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    ref: _ctx.onModalRef,
    isCustomTitle: "",
    showFooter: false,
    contentPadding: "",
    onClose: _ctx.onClose,
    scrollable: false,
    titlePadding: "px-8 py-2",
    "data-testid": "booking-v4-commodity-modal"
  }, {
    "custom-title": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.title")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("input", {
            "data-testid": "booking-v4-commodity-modal-search",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputSearch && _ctx.onInputSearch(...args))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = true)),
            value: _ctx.search,
            placeholder: 
              _ctx.$t('bookingV4.goods.commodity.modal.searchPlaceholder')
            ,
            class: 
              `${
                _ctx.search ? 'text-black-lp-200' : 'text-gray-lp-500'
              } block appearance-none w-full bg-white border border-gray-lp-400 px-3 py-2.5 xxl:py-2.5 pl-10 rounded leading-tight focus:outline-none`
            
          }, null, 42, ["value", "placeholder"]),
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createBlock("svg", {
              class: "w-4 cursor-pointer",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
            }, [
              _hoisted_6
            ], 512)), [
              [_vShow, _ctx.search]
            ])
          ])
        ])
      ])
    ]),
    content: _withId(() => [
      (_ctx.isFocused && _ctx.search.length)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.searchResult")), 1),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "2.5rem"
                    })
                  ])
                ]))
              : (_ctx.searchResults.length)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.searchResult")), 1),
                    _createVNode("div", _hoisted_13, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchResults, (item) => {
                        return (_openBlock(), _createBlock("label", {
                          key: item.id,
                          "data-testid": `booking-v4-commodity-modal-item-${item.id}`,
                          class: "cursor-pointer relative block overflow-hidden hover:bg-gray-lp-1000",
                          onClick: ($event: any) => (_ctx.onSelect(item))
                        }, [
                          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.ellipsisText(_ctx.displayName(item), 40)), 1)
                        ], 8, ["data-testid", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.searchResult")), 1),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.emptySearch")), 1),
                      _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.emptySearchDescription")), 1)
                    ])
                  ]))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.mostUsed")), 1),
              _createVNode("div", _hoisted_24, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendedCommodities, (recommend) => {
                  return (_openBlock(), _createBlock("label", {
                    key: recommend.id,
                    "data-testid": `booking-v4-commodity-modal-item-${recommend.id}`,
                    class: [
                'w-full flex flex-row justify-between cursor-pointer relative overflow-hidden',
                _ctx.selectedSearchItem === recommend.code
                  ? 'bg-gray-lp-1000'
                  : 'hover:bg-gray-lp-1000'
              ],
                    onMousedown: ($event: any) => (_ctx.onSelect(recommend))
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      name: `commodity-search-modal`,
                      value: recommend.code,
                      id: `search-commodity-${recommend.id}`,
                      onChange: ($event: any) => (_ctx.selectedSearchItem = recommend.code),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.onSelect(recommend)), ["prevent"]), ["space"]),
                      onFocus: ($event: any) => (_ctx.selectedSearchItem = recommend.code),
                      class: "z-10 absolute opacity-0"
                    }, null, 40, ["value", "id", "onChange", "onKeydown", "onFocus"]),
                    _createVNode("div", _hoisted_25, _toDisplayString(_ctx.ellipsisText(_ctx.displayName(recommend), 40)), 1),
                    _createVNode("div", _hoisted_26, [
                      (recommend.isQuarantine)
                        ? (_openBlock(), _createBlock("span", _hoisted_27, " K "))
                        : _createCommentVNode("", true),
                      (recommend.isDangerousGoods)
                        ? (_openBlock(), _createBlock("span", _hoisted_28, " DG "))
                        : _createCommentVNode("", true)
                    ])
                  ], 42, ["data-testid", "onMousedown"]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createBlock("label", {
                    key: category.code,
                    class: [
                'flex justify-between py-2 cursor-pointer relative overflow-hidden',
                _ctx.isCategorySelected(category.code)
                  ? 'bg-gray-lp-1600'
                  : 'hover:bg-gray-lp-1600'
              ],
                    onClick: ($event: any) => (_ctx.onSelectCategory(category.code))
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      name: 'commodity-category-selection',
                      value: category.code,
                      id: `category-selection-${category.code}`,
                      checked: _ctx.isCategorySelected(category.code),
                      onChange: ($event: any) => (_ctx.onSelectCategory(category.code)),
                      class: "z-10 absolute opacity-0"
                    }, null, 40, ["value", "id", "checked", "onChange"]),
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.displayCategory(category)), 1),
                    _createVNode(_component_Icons, {
                      name: "chevron-right-thin",
                      style: {"width":"6px"}
                    })
                  ], 10, ["onClick"]))
                }), 128))
              ]),
              (_ctx.loadingCategory)
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "2.5rem"
                    }),
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "2.5rem"
                    }),
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "2.5rem"
                    })
                  ]))
                : (_ctx.categoryCommodities.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryCommodities, (item) => {
                        return (_openBlock(), _createBlock("label", {
                          key: item.id,
                          "data-testid": `booking-v4-commodity-modal-item-${item.id}`,
                          class: [
                'w-full flex flex-row justify-between items-center p-2 text-sm cursor-pointer relative overflow-hidden',
                _ctx.selectedCategoryItem === item.code
                  ? 'bg-gray-lp-1000'
                  : 'hover:bg-gray-lp-1000'
              ],
                          onMousedown: ($event: any) => (_ctx.onSelect(item))
                        }, [
                          _createVNode("input", {
                            type: "radio",
                            name: `commodity-category-modal`,
                            value: item.code,
                            id: `category-commodity-${item.code}`,
                            onChange: ($event: any) => (_ctx.selectedCategoryItem = item.code),
                            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.onSelect(item)), ["prevent"]), ["space"]),
                            onFocus: ($event: any) => (_ctx.selectedCategoryItem = item.code),
                            class: "z-10 absolute opacity-0"
                          }, null, 40, ["value", "id", "onChange", "onKeydown", "onFocus"]),
                          _createVNode("div", _hoisted_34, _toDisplayString(_ctx.displayName(item)), 1),
                          _createVNode("div", _hoisted_35, [
                            (item.isQuarantine)
                              ? (_openBlock(), _createBlock("span", _hoisted_36, " K "))
                              : _createCommentVNode("", true),
                            (item.isDangerousGoods)
                              ? (_openBlock(), _createBlock("span", _hoisted_37, " DG "))
                              : _createCommentVNode("", true)
                          ])
                        ], 42, ["data-testid", "onMousedown"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("bookingV4.goods.commodity.modal.emptyCategory")), 1)
                    ]))
            ])
          ]))
    ]),
    _: 1
  }, 8, ["onClose"]))
})